var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-dropdown-divider'),_c('dropdown-section-title',{attrs:{"title":"Documentos Excel","icon":"icon-download"}}),_c('dropdown-option-item',{attrs:{"icon":"icon-download"},on:{"click":_vm.export_excel}},[_vm._v(" Exportar Excel ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }